import React from "react";
import { Empty, Select, Spin } from "antd";
import { map , noop} from "lodash";

import "./simpleSelect.scss";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { GLOBAL_SEARCH_DROPDOWN_KEY } from "@utils/constants";

const { Option } = Select;

export function CustomOption({title = '', subtitle, sideHeader, customOption }: { title: string; subtitle: string; sideHeader: string; customOption: string }) {
  if (customOption === GLOBAL_SEARCH_DROPDOWN_KEY) {
    return (
      <div className="ui-select-option_header">
        <div className="ui-select-option_section1">
          <span className="ui-select-option_section1--title">{title}</span>
          <span className="ui-select-option_section1--subtitle">{subtitle}</span>
        </div>
        <div className="ui-select-option_section2">
          <span className="ui-select-option_section2--subtitle">{sideHeader}</span>
        </div>
      </div>
    );
  } 

  return <p>Provide correct Custom option key</p>
}

const SimpleSelect = ({
  className = '',
  handleSelect,
  value,
  options,
  disabled = false,
  loadingOptions,
  placeholder,
  minWidth,
  customOption = '',
  dropdownStyle = {},
  bordered = true,
  onSearch = noop,
  onFocus = noop,
  noDataFound = loadingOptions ? <Spin size="small" indicator={<HealthemSpinner />} /> : <Empty />,
  defaultValue = undefined,
  style = { width: 260 },
  allowClear = false
}: {
  className?: string;
  handleSelect: (arg0: any, arg1?: any) => void;
  value: any;
  options: any;
  disabled?: boolean;
  loadingOptions?: boolean;
  placeholder?: string;
  minWidth?: boolean;
  customOption ?: string;
  dropdownStyle ?: any;
  bordered ?: boolean;
  onSearch ?: any;
  onFocus ?:  any;
  noDataFound ?: any;
  defaultValue ? : undefined | string;
  style ?: any;
  allowClear ?: boolean;
}) => {

  return (
    <Select
      className={`ui-select ${className}`}
      // style={minWidth ? { minWidth: 220, maxWidth: 350 } : { width: 260 }}
      style={style}
      placeholder={placeholder || "Select Option"}
      optionFilterProp="children"
      onChange={(value, option: any) => handleSelect(value, option)}
      onKeyDown={
        ev => {
          if (ev.code === 'Backspace') {
            handleSelect(null, {})
          } 
        }
      }
      value={value}
      bordered={bordered}
      // suffixIcon={
      //   <span>
      //     <img src={IconChevron} alt="chevron-icon" />
      //   </span>
      // }
      showSearch
      notFoundContent={noDataFound}
      filterOption={(input, option: any) => {
        return (option.label || "").toLowerCase().includes(input.toLowerCase());
      }}
      disabled={disabled ? disabled : false}
      getPopupContainer={(trigger) => trigger.parentNode}
      dropdownStyle={dropdownStyle}
      onSearch={onSearch}
      onFocus={onFocus}
      defaultValue={defaultValue}
      allowClear={allowClear}
    >
      {options.length > 0
        ? map(
            options.filter((op: any) => op),
            (option: any) => {
              return (
                <Option key={option.value} value={option.value} className="ui-select-option" disabled={option.disabled} label={`${option.title || ""} ${option.subtitle || ""}`}>
                    {customOption ? <CustomOption title={option.title} subtitle={option.subtitle} sideHeader={option.sideHeader} customOption={customOption}/> : option.title}
                </Option>
              );
            }
          )
        : !loadingOptions && customOption !== 'global_search' && (
            <Option key="1" value="" className="ui-select-option">
              {" "}
            </Option>
          )}
    </Select>
  );
};

export default SimpleSelect;
